<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">样衣类别</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label" require>分类名</div>
            <label
              ><input type="text" class="cg-input" v-model="form.flname"
            /></label>
          </div>
          <div class="item col-1">
            <el-button class="publish-btn" size="small" @click="addUser"
              >新增</el-button
            >
          </div>
        </div>
      </div>
      <div class="form-options"></div>
    </div>
    <el-table
      :data="users"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" prop="name" label="分类名" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label" require>分类名</span>
          <label
            ><input type="text" class="cg-input" v-model="upflname"
          /></label>
        </div>
        <div class="footer">
          <el-button class="publish-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, reactive, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

//弹窗字段
const upflname = ref("");
const upid = ref("");

const form = reactive({
  flname: "", //分类名
});
const dialogTableVisible = ref(false); //弹窗控制
const users = ref([]); // 分类列表

// 缓存值
const STORAGE_KEY = "product-category";

// 监听查询条件
watch([() => form.flname], () => {
  const searchParams = {
    flname: form.flname,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});
// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      form.flname = cache.flname ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const save = async () => {
  if (!upflname.value.trim()) {
    proxy.$message.error("分类名必填");
    return false;
  }
  const sendata = {
    id: upid.value, //分类id
    name: upflname.value, //分类名
  };
  console.log(sendata, "传的参数对不对");
  const res = await proxy.$api.System.ProductCategory.update(sendata);
  if (res.data.code == 200) {
    dialogTableVisible.value = false;
    proxy.$message.success("修改成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
  }
};

const up = (row) => {
  console.log(row, "拿到的是不是当行数据");
  upflname.value = row.name;
  upid.value = row.id;
  dialogTableVisible.value = true;
};

const getList = async () => {
  const sendata = {};
  const res = await proxy.$api.System.ProductCategory.get(sendata);
  console.log(res.data.code);
  if (res.data.code == 200) {
    users.value = res.data.data.list;
    console.log(users.value, "返回的列表是什么格式");
  } else {
    proxy.$message.error("网络错误");
    users.value = [];
  }
};

const addUser = async () => {
  if (!form.flname.trim()) {
    proxy.$message.error("分类名必填");
    return false;
  }
  const sendata = {
    name: form.flname,
  };
  console.log(sendata, "看看参数是否正确");
  const res = await proxy.$api.System.ProductCategory.add(sendata);
  if (res.data.code == 200) {
    form.flname = "";
    proxy.$message.success("新增成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
    form.flname = "";
  }
};

const delUser = async (id) => {
  const sendata = { id: id };
  const res = await proxy.$api.System.ProductCategory.del(sendata);
  if (res.data.code == 200) {
    form.flname = "";
    proxy.$message.success("删除成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
    form.flname = "";
  }
};

onMounted(() => {
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./product-category";
.panel-title {
  color: #999;
}
.publish-btn {
  background-color: #ff9900;
}
</style>
